import React from 'react';

import { SignupProgressIndicator } from './components/SignupProgressIndicator';
import { useIsInvoiceFinanceSignup } from './steps/useIsInvoiceFinanceSignup';
import { useIsErrorStep } from './steps/useRedirectToLatestStep';
import { useSellerWhitelabelling } from '../../hooks/useSellerWhiteLabelling.hook';
import { useCurrentPayLink } from '../Checkout/hooks/useCurrentPayLink';
import { CancelButton } from '../components/CancelButton/CancelButton';
import { HelpBox } from '../components/HelpBox/HelpBox';
import { WhiteLabelHeaderLogo } from '../components/WhiteLabelLogo/WhiteLabelLogo';
import { WhiteLabelOverride } from '../components/WhiteLabelOverride/WhiteLabelOverride';

export const SignupLayout = ({
  wideWidth = false,
  children,
}: {
  wideWidth?: boolean;
  children: React.ReactNode;
}) => {
  const { payLink } = useCurrentPayLink();
  const cancelUrl = payLink?.cancel_url;
  const isInvoiceFinance = useIsInvoiceFinanceSignup();
  const isErrorStep = useIsErrorStep();

  // White-label theme.
  const { theme, showSellerLogo } = useSellerWhitelabelling(
    payLink?.seller_handle,
  );

  return (
    <div className="min-h-screen overflow-hidden bg-secondary-97 text-left text-m font-med [&_label]:!font-med">
      <div className="mx-auto max-w-[600px]">
        {showSellerLogo && (
          <WhiteLabelHeaderLogo
            // showSellerLogo = true --> logo_uri & preferred_logo_type present.
            url={theme!.logo_uri!}
            ratio={theme!.preferred_logo_type!}
          />
        )}
        {!isInvoiceFinance && (
          <WhiteLabelOverride componentType="progress">
            <SignupProgressIndicator />
          </WhiteLabelOverride>
        )}
      </div>

      <div
        className={`mx-auto ${wideWidth ? 'max-w-[720px]' : 'max-w-[600px]'}`}
      >
        <CancelButton className="mb-s" href={cancelUrl ?? undefined} />
        {children}
        {!isErrorStep && <HelpBox />}
      </div>
    </div>
  );
};
